import React from "react";
import styled from "styled-components";

const StyledMobileMenu = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 19;
    background-color: rgba(0, 0, 0, 0.9);
    text-align: center;
    overflow-y: auto;
    padding: 130px 15% 40px;

    .mob-link {
        display: block;
        color: #fff;
        margin-bottom: 40px;
        font-weight: 400;
        font-family: 'Urbanist', serif;
        font-size: 18px;
    }

    .btn-xao-md {
        width: 100%;
        border-radius: 4px;
        display: block;
        padding: 10px;
    }
`;

const mobLinks: any = [
    {
        label: 'Exchange',
        link: 'https://my.ncx.cx/'
    },
    {
        label: 'Trade',
        link: 'https://trade.ncx.cx'
    },
    {
        label: 'DEX',
        link: 'https://bsc.ncx.cx/swap'
    },
    {
        label: 'Markets',
        link: 'https://ncx.cx'
    },
    {
        label: 'Connect',
        link: 'https://ncx.cx/blog'
    },
    {
        label: 'Documentation',
        link: 'https://docs.ncx.cx/'
    },
];

const MobileMenu = () => {
    return <StyledMobileMenu>
        {mobLinks.map(item=><a className='mob-link' target={item.target || '_blank'} href={item.link} >{item.label}</a>)}
        <a className="btn-xao-md" href="https://my.ncx.cx/en/login" target="_blank" rel="noreferrer" >Sign in</a>
        {/* <a className="btn-blue" href="/" target="_blank" rel="noreferrer" >Launch DEX</a> */}
    </StyledMobileMenu>
}

export default MobileMenu;